"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[504],{

/***/ 3726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FieldText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
;// CONCATENATED MODULE: ./src/components/Form/FieldError.tsx


const FormFieldError = ({ name , validator  })=>{
    if (validator) {
        let message = "Error";
        let isError = false;
        const { hook  } = validator;
        const { formState: { errors  }  } = hook;
        if (errors && typeof errors[name] !== "undefined") {
            isError = true;
            if (errors[name]?.message) {
                message = errors[name]?.message;
            }
        }
        if (isError) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-8 text-12 text-red-70",
                children: message
            });
        }
        return null;
    }
    return null;
};
/* harmony default export */ var FieldError = (FormFieldError);

;// CONCATENATED MODULE: ./src/components/Form/Field.tsx



const FormField = ({ name , label , validator , children , className , info , islast , isFull , required , additionalInfo , messageError  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${!islast ? "mb-24" : ""} ${className || ""} ${isFull ? "w-full" : ""}`,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: additionalInfo ? "mb-4" : "mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    className: "text-b1 text-neutral-80 font-medium mb-0 block flex gap-4",
                    children: [
                        label,
                        " ",
                        required && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-red-50 font-medium",
                            children: "*"
                        })
                    ]
                })
            }),
            additionalInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-light text-b2",
                    children: additionalInfo
                })
            }),
            children,
            name && validator && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldError, {
                name: name,
                validator: validator
            }),
            messageError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-8 text-12 text-red-70",
                children: messageError
            }),
            info && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-8 mb-0 text-12 text-neutral-50",
                children: info
            })
        ]
    });
};
/* harmony default export */ var Field = (FormField);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(4180);
;// CONCATENATED MODULE: ./src/components/Form/InputBase.tsx


const style = "w-full px-8 h-40 bg-field_input text-b1 text-neutral-80 border border-neutral40_to_dark20 rounded-4 disabled:bg-light_neutral10_to_dark_neutral50 placeholder-input_placeholder placeholder:font-light focus-visible:outline-2 focus-visible:outline-blue-50";
const FormInputBase = ({ name , validator , classBase , onRender , defaultValue ="" , afterInput , beforeInput , iconBeforeInput  })=>{
    const renderInput = ()=>{
        const { hook , rules  } = validator;
        const { control  } = hook;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            name: name,
            control: control,
            defaultValue: defaultValue,
            rules: rules,
            render: ({ field  })=>onRender(field)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `relative ${classBase || ""}`,
        children: [
            beforeInput,
            iconBeforeInput && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `absolute left-12 z-10 flex items-center h-full`,
                children: iconBeforeInput
            }),
            validator ? renderInput() : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: onRender({})
            }),
            afterInput
        ]
    });
};
/* harmony default export */ var InputBase = (FormInputBase);

;// CONCATENATED MODULE: ./src/components/Form/FieldText.tsx



const FormFieldText = (props)=>{
    const { name , validator , children , type , defaultValue , afterInput , beforeInput , inputStyle , classBase , iconBeforeInput , ...others } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Field, {
        name: name,
        validator: validator,
        ...others,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase, {
            name: name,
            defaultValue: defaultValue,
            validator: validator,
            afterInput: afterInput,
            beforeInput: beforeInput,
            iconBeforeInput: iconBeforeInput,
            classBase: classBase,
            onRender: (field)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    className: `${style} ${inputStyle || ""}`,
                    type: type,
                    id: `input-${name}`,
                    ...field,
                    ...others
                })
        })
    });
};
/* harmony default export */ var FieldText = (FormFieldText);


/***/ }),

/***/ 9504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ HomePopUp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./src/data/locales/id/business.json
var business = __webpack_require__(8593);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./src/modules/Home/popupStore.ts
var popupStore = __webpack_require__(5803);
// EXTERNAL MODULE: ./src/components/Icon/IconCheckCircle.tsx
var IconCheckCircle = __webpack_require__(4110);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx + 1 modules
var Image_Image = __webpack_require__(2317);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(1774);
// EXTERNAL MODULE: ./src/lib/gtag.ts
var gtag = __webpack_require__(5789);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var components_Button = __webpack_require__(1097);
;// CONCATENATED MODULE: ./src/modules/Business/HomeInstitutions.tsx







const BestCompanies = [
    {
        id: 1,
        name: "AWS",
        image_url: "https://staging-static.gokampus.com/course-institutions/AsRWHzve28oQ7YsppqsN8uYvH84V0oG3tEgXaQGK.png"
    },
    // {
    //   id: 2,
    //   name: "NUS",
    //   image_url:
    //     // "https://s.gokampus.com/course-institutions/molPsNk6ieF1vnM8XPVAJBN9T7dXUNqwRY75ZmPe.png",
    //     "https://staging-static.gokampus.com/course-institutions/HcfXGXMCqBDYMEc7f4fAjzM3uh4zzXUe7b2MoKfr.png",
    // },
    {
        id: 2,
        name: "ESQ",
        image_url: "https://s.gokampus.com/course-institutions/IVP2BFrctpg4NsitZCo9S8GVyJ9QPxI14HfPGGX3.png"
    },
    {
        id: 3,
        name: "PrasMul",
        image_url: "https://s.gokampus.com/course-institutions/3aTdRP4IGwGrcg4WYhdHB9pDdKBq84hQ4rSiGXDv.png"
    },
    {
        id: 4,
        name: "UPH",
        image_url: "https://s.gokampus.com/course-institutions/YtbTat9wquzhf4o7Ez26cGmfswHn3rVkOb6DAd2u.png"
    },
    {
        id: 5,
        name: "Meta",
        image_url: "https://s.gokampus.com/provider/meta_spark.png"
    },
    {
        id: 6,
        name: "Tiktok",
        image_url: "https://s.gokampus.com/course-institutions/xFmcLEx9ssCs6M2mRblgspCLckDGhBul77MImhWs.png"
    },
    {
        id: 7,
        name: "Tokopedia",
        image_url: "https://s.gokampus.com/course-institutions/6lJBZv7cpaL9dkXqI9eY2J5BUYmWPDm1gGVHWv3U.png"
    },
    {
        id: 8,
        name: "UiPath",
        image_url: "https://s.gokampus.com/course-institutions/5EWzRJoYneG0lLI73q0vMhPT5QJmyBN5cfQa6F52.png"
    },
    {
        id: 9,
        name: "James Gwee",
        image_url: "https://s.gokampus.com/course-institutions/Fea14Pf04sLxrMMJX4WeIMuygtN2Q1J5xi4Zmc2f.png"
    },
    {
        id: 10,
        name: "Merry Riana",
        image_url: "https://s.gokampus.com/provider/merry_riana_group.png"
    },
    {
        id: 11,
        name: "Laruno (TDW)",
        image_url: "https://s.gokampus.com/course-institutions/Wn5HiLGGlGej7dhFHL0DUSCSQeUkuo58iUPX0ibY.png"
    },
    {
        id: 12,
        name: "Mindtera",
        image_url: "https://s.gokampus.com/course-institutions/tCpfhoqLExfpD2O92XRxTj35MWEC6RZNENoFHpeo.png"
    }
];
const HomeInstitutions = ()=>{
    const headingSectionInstitution = TranslationID["HomeInstitution"];
    const { showPopupFormSales  } = usePopupStoreFormSales((state)=>({
            showPopupFormSales: state.showPopupFormSales
        }));
    const onClickImages = ()=>{
        pushDataLayer({
            event: "cta-partner"
        });
        showPopupFormSales("");
    };
    const onClickSeeMoreInstitution = ()=>{
        pushDataLayer({
            event: "cta-partner-see-more"
        });
        showPopupFormSales("");
    };
    return /*#__PURE__*/ _jsx("section", {
        id: "home-institution",
        children: /*#__PURE__*/ _jsx(ContainerDesktop, {
            className: "pt-20 pb-52 sm-max:py-36",
            useAuto: true,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "grid gap-36 text-center pt-24",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-b1 font-medium text-neutral-80",
                        children: headingSectionInstitution.title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "cursor-pointer",
                        onClick: ()=>onClickImages(),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grid gap-30 grid-cols-6 lg-max:grid-cols-3 sm-max:!grid-cols-2",
                            children: BestCompanies.map((institution)=>/*#__PURE__*/ _jsx("div", {
                                    className: "aspect-[2/1] lg-max:aspect-[2/1] py-8 px-4 bg-white shadow-chip_total rounded-8",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: institution.image_url,
                                        alt: institution.name,
                                        className: `w-full h-full object-contain`
                                    })
                                }, Math.random()))
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative",
                        onClick: onClickSeeMoreInstitution,
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "secondary_transparant",
                            children: "Lihat Semua"
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/Form/FieldText.tsx + 3 modules
var FieldText = __webpack_require__(3726);
// EXTERNAL MODULE: ./src/modules/Business/businessApi.ts
var businessApi = __webpack_require__(1418);
// EXTERNAL MODULE: ./src/components/Toast/toastStore.ts
var toastStore = __webpack_require__(2505);
;// CONCATENATED MODULE: ./src/modules/Business/HomePopUp.tsx












const HomePopUp = ({ eventId ="popup-sales" , forHris =false  })=>{
    const textDocs = business/* PopupFormSales */.fG;
    const { closePopupFormSales , currentCtaEvent  } = (0,popupStore/* usePopupStoreFormSales */.p)((state)=>({
            closePopupFormSales: state.closePopupFormSales,
            currentCtaEvent: state.currentCtaEvent
        }));
    const [name, setName] = (0,react.useState)("");
    const [company, setCompany] = (0,react.useState)("");
    const [contact, setContact] = (0,react.useState)("");
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const showToast = (0,toastStore/* useToastStore */.E)((state)=>state.showToast);
    const usePostApi = (0,businessApi/* usePostContactBusiness */.g)();
    const [nameError, setNameError] = (0,react.useState)(false);
    const [companyError, setCompanyError] = (0,react.useState)(false);
    let finalEvent = eventId;
    if (currentCtaEvent != "") finalEvent = currentCtaEvent;
    const submit = ()=>{
        setIsLoading(true);
        if (!contact) {
            showToast({
                type: "danger",
                message: "Pastikan kontak anda sudah diisi"
            });
            setIsLoading(false);
            return;
        }
        if (company.length > 0 && company.length < 5) {
            showToast({
                type: "danger",
                message: "Pastikan nama perusahaan Anda diisi dengan minimal 5 karakter"
            });
            setIsLoading(false);
            return;
        }
        if (name.length > 0 && name.length < 3) {
            showToast({
                type: "danger",
                message: "Pastikan nama Anda diisi dengan minimal 3 karakter"
            });
            setIsLoading(false);
            return;
        }
        const urlOrigin = window.location.href + "?event=" + finalEvent;
        usePostApi.doFetch({
            // @ts-ignore
            name,
            // @ts-ignore
            company_name: company,
            contact,
            url_origin: urlOrigin
        }, {
            onSuccess (res) {
                (0,gtag/* pushDataLayer */.zz)({
                    event: "success-leads"
                });
                closePopupFormSales();
                // reset form field
                setName("");
                setCompany("");
                setContact("");
                //@ts-ignore
                if (res.message === "success") {
                    showToast({
                        type: "success",
                        message: "Kontak anda berhasil terkirim"
                    });
                    setIsLoading(false);
                }
            },
            onError (err) {
                showToast({
                    type: "danger",
                    message: err.data?.message ?? err.message ?? "Error"
                });
                setIsLoading(false);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "items-center grid grid-cols-2 gap-x-[42px] lg-max:grid-cols-1 2xl-max:gap-y-[42px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg-max:order-last flex flex-col gap-20 text-left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: textDocs.title
                        },
                        className: "font-black text-h2 lg-max:text-h3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-medium text-b1 lg-max:text-b1 text-",
                        children: textDocs.description
                    }),
                    textDocs.benefits.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid",
                        children: textDocs.benefits.map((elm)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-start items-center gap-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-24",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheckCircle/* IconCheckCircle */.B, {
                                            color: "#883CFF",
                                            size: 24
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-left text-neutral-80 font-light",
                                        dangerouslySetInnerHTML: {
                                            __html: elm
                                        }
                                    })
                                ]
                            }, elm))
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-medium text-b1 lg-max:text-b1 text-",
                        children: textDocs.institutionTitle
                    }),
                    BestCompanies && BestCompanies.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid gap-20 grid-cols-6 lg-max:grid-cols-4 hg-max:!grid-cols-3",
                        children: BestCompanies.map((institution)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-56 h-56 m-auto sm-max:w-32 sm-max:h-32",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                                    width: 56,
                                    height: 56,
                                    src: institution.image_url,
                                    alt: institution.name,
                                    className: `w-full h-full`
                                })
                            }, institution.id + Math.random()))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "!bg-white flex flex-col gap-8 shadow-chip_total rounded-16 bg-chip-pattern p-32",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-black text-h3 lg-max:text-h5",
                            children: textDocs.contactSales
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-light text-b1 sm-max:text-b1 py-4",
                            children: textDocs.contactSalesDesc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-medium text-b2 text-neutral-60",
                            children: [
                                textDocs.fieldContactInput,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-thin",
                                    children: "(wajib diisi)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldText/* default */.Z, {
                            name: "contact",
                            islast: true,
                            classBase: "h-full sm-max:w-full",
                            inputStyle: "!rounded-8 h-40 sm-max:!w-full",
                            placeholder: textDocs.fieldContactPlaceholder,
                            value: contact,
                            onChange: (e)=>setContact(e.target.value)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-medium text-b2 text-neutral-60",
                            children: [
                                textDocs.fieldCompanyInput,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-thin",
                                    children: "(opsional)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldText/* default */.Z, {
                            name: "contact",
                            islast: true,
                            classBase: "h-full sm-max:w-full",
                            inputStyle: "!rounded-8 h-40 sm-max:!w-full",
                            placeholder: textDocs.fieldCompanyPlaceholder,
                            value: company,
                            onChange: (e)=>{
                                const value = e.target.value;
                                setCompany(value);
                                setCompanyError(value.length > 0 && value.length < 5);
                            }
                        }),
                        companyError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[11px] font-thin text-[#FF0000] italic",
                            children: "Minimal 5 karakter"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-medium text-b2 text-neutral-60",
                            children: [
                                textDocs.fieldNameInput,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-thin",
                                    children: "(opsional)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldText/* default */.Z, {
                            name: "name",
                            islast: true,
                            classBase: "h-full sm-max:w-full",
                            inputStyle: "!rounded-8 h-40 sm-max:!w-full",
                            placeholder: textDocs.fieldNamePlaceholder,
                            value: name,
                            onChange: (e)=>{
                                const value = e.target.value;
                                setName(value);
                                setNameError(value.length > 0 && value.length < 3);
                            }
                        }),
                        nameError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[11px] font-thin text-[#FF0000] italic",
                            children: "Minimal 3 karakter"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-8"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                            className: `flex justify-center items-center gap-8 !rounded-8 !text-b1`,
                            onClick: ()=>{
                                (0,gtag/* pushDataLayer */.zz)({
                                    event: finalEvent
                                });
                                submit();
                            },
                            isFull: true,
                            state: isLoading ? "loading" : "active",
                            children: textDocs.fieldSubmit
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 1418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ usePostContactBusiness; }
/* harmony export */ });
/* harmony import */ var lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9208);

//@ts-ignore
const usePostContactBusiness = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("post", "/tenants/business-contact");


/***/ })

}]);